var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.5V13.1667C13.3334 12.4594 13.0525 11.7811 12.5524 11.281C12.0523 10.781 11.374 10.5 10.6667 10.5H5.33341C4.62617 10.5 3.94789 10.781 3.4478 11.281C2.9477 11.7811 2.66675 12.4594 2.66675 13.1667V14.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 7.83333C9.47268 7.83333 10.6666 6.63943 10.6666 5.16667C10.6666 3.69391 9.47268 2.5 7.99992 2.5C6.52716 2.5 5.33325 3.69391 5.33325 5.16667C5.33325 6.63943 6.52716 7.83333 7.99992 7.83333Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeader);
export default __webpack_public_path__ + "static/media/user__header.3e478505fb273b3ae14a7c2679acbca7.svg";
export { ForwardRef as ReactComponent };